import fetchAPI from '../../../../lib/utils/fetch-api'
import {
  fileToBase64,
  parseChatFileUploadConfig,
  uploadChatFileWithTransport,
} from '../../../lib/chat-files/chat-file-upload'
import { uploadChatFileInChunks } from '../../../lib/chat-files/chat-file-chunk-upload'

export const supplyRequest = async (url: string, options: any = {}) => {
  const result = await fetchAPI(url, options)
  if (result.error || result.errors)
    throw new Error(
      typeof result.error === 'string'
        ? result.error
        : result.error?.message || result.errors?.join(', ') || 'Не удалось выполнить запрос',
    )
  return result
}

export const uploadDeliveryFile = async (
  file: File,
  chatId: string,
  attemptId: string,
  onProgress: (percent: number) => void,
) => {
  const config = parseChatFileUploadConfig(
    (await supplyRequest('/api/mcp2/chat/files/upload-config')).data,
  )
  const query = new URLSearchParams({ agent_id: chatId, upload_attempt_id: attemptId })
  const endpoint = `/api/mcp2/chat/files/upload?${query}`
  const uploaded = await uploadChatFileWithTransport({
    config,
    fileSize: file.size,
    report: () => {},
    uploadMultipart: async () => {
      const body = new FormData()
      body.append('file', file)
      body.append('name', file.name)
      body.append('mime_type', file.type)
      body.append('upload_attempt_id', attemptId)
      const controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), 180000)
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'include',
          body,
          signal: controller.signal,
        })
        const result = await response.json()
        if (!response.ok || result.error)
          throw Object.assign(
            new Error(result.error?.message || result.error || 'Не удалось загрузить файл'),
            { statusCode: response.status },
          )
        return result
      } finally {
        clearTimeout(timeout)
      }
    },
    uploadJson: async () =>
      supplyRequest(endpoint, {
        method: 'POST',
        timeoutMs: 180000,
        body: JSON.stringify({
          name: file.name,
          mime_type: file.type,
          content_base64: await fileToBase64(file),
          upload_attempt_id: attemptId,
        }),
      }),
    uploadChunks: config.chunk_upload
      ? () =>
          uploadChatFileInChunks({
            file,
            agentId: chatId,
            attemptId,
            config: config.chunk_upload!,
            isCancelled: () => false,
            request: (body, signal) =>
              supplyRequest(`/api/mcp2/chat/files/upload-chunks?${query}`, {
                method: 'POST',
                body: JSON.stringify(body),
                signal,
                timeoutMs: 65000,
              }),
            onProgress: (loaded, total) => onProgress(Math.round((loaded / total) * 100)),
          })
      : undefined,
  })
  if (!uploaded?.data?.path) throw new Error('Файл загружен без ссылки. Повторите загрузку')
  onProgress(100)
  return uploaded.data
}
